// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2By7p","col":"CardReaderDesc_col__2_Ved","label":"CardReaderDesc_label__-wPcd"};